//#region all possible settings/components/features descriptions
/**
 * '1': { component: '', title: 'Input type', desc: "SW (SW1) Switch type. This parameter defines how the Device should treat the switch (which type) connected to the SW (SW1) terminal.Value size: 1 Byte Default value: 2 Values & descriptions:0 - momentary switch,1 - toggle switch (contact closed - ON / contact opened - OFF),2 - toggle switch (device changes status when switch changes status)" },
 * '2': { component: '', title: 'Input type', desc: "SW2 Switch type This parameter defines how the Device should treat the switch (which type) connected to the SW2 terminal. Value size: 1 Byte Default value: 2 Values & descriptions: 0 - momentary switch (push button), 1 - toggle switch (contact closed - ON / contact opened - OFF), 2 - toggle switch (device changes status when switch changes status)" },
 * '5': { component: '', title: 'INVERT OUTPUT', desc: " Output orientation This parameter allows to reverse the operation of O1 and O2 without changing the wiring (in case of invalid motor connection) to ensure proper operation. Value size: 1 Byte Default value: 0 Values & descriptions: 0 - default (O1 - UP, O2 - DOWN) 1 - reversed (O1 - DOWN, O2 - UP)" },
 * '6': { component: '', title: 'SWAP INPUT', desc: " Inputs SW1 & SW2 Swap This parameter allows to swap the operation of switches connected to inputs SW1 and SW2 without changing the wiring. Value size: 1 Byte Default value: 0 Values & descriptions: 0 - default (SW1 - O1, SW2 - O2), 1 - swapped (SW1 - O2, SW2 - O1)" },
 * '16': { component: '', title: 'SWAP OUTPUTS', desc: "Outputs O1 & O2 swap This parameter allows to swap the operation of outputs O1 and O2 without changing the wiring (in case of an invalid motor connection) to ensure proper operation. Values size: 1 Byte Default value: 0 Values & descriptions: 0 - default 1 - reversed" },
 * '17': { component: '', title: 'Power on default', desc: "Restore state of O (O1) after power failure. This parameter determines if the on/off status is saved and restored for the load connected to O (O1) after a power failure. Values  size: 1 Byte. Default value: 0 Values & descriptions: 0 - Device saves last on/off status and restores it after a power failure 1 - Device does not save on/off status and does not restore it after a power failure, it remains off" },
 * '18': { component: '', title: 'Power on default', desc: "Restore the O2 state after a power failure This parameter determines if the on/off status is saved and restored for the load connected to O2 after a power failure. Values size: 1 Byte Default value: 0 Values & descriptions: 0 - Device saves last on/off status and restores it after a power failure 1 - Device does not save on/off status and does not restore it after a power failure, it remains off" },
 * '19': { component: '', title: 'Auto OFF', desc: " O (O1) Auto OFF with timer If the load O (O1) is ON, you can schedule it to turn OFF automatically after the period of time defined in this parameter. The timer resets to zero each time the Device receives an ON command, either remotely (from the gateway or associated device) or locally from the switch. Values size: 2 Byte Default value: 0 Values & their descriptions: 0 - Auto OFF Disabled 1 - 32535 = 1 - 32535 seconds or milliseconds – see Parameter no. 25. Set timer units to s or ms for O (O1) resolution 100ms" },
 * '20': { component: '', title: 'Auto ON', desc: " O (O1) Auto ON with timer If the load O (O1) is ON, you can schedule it to turn OFF automatically after the period of time defined in this parameter. The timer resets to zero each time the Device receives an ON command, either remotely (from the gateway or associated device) or locally from the switch. Values size: 2 Byte Default value: 0 Values & their descriptions: 0 - Auto ON Disabled 1 - 32535 = 1 - 32535 seconds (or milliseconds – see Parameter No. 25. Set timer units to s or ms for O (O1) resolution 100ms" },
 * '21': { component: '', title: 'AUTO OFF', desc: " O2 Auto OFF with timer If the load O2 is ON, you can schedule it to turn OFF automatically after the period of time defined in this parameter. The timer resets to zero each time the device receives an ON command, either remotely (from the gateway or associated device) or locally from the switch. Values size: 2 Byte Default value: 0 Values & their descriptions: 0 - Auto OFF Disabled1 - 32535 = 1 - 32535 seconds (or milliseconds – see Parameter no. 26. Set timer units to s or ms for O2 resolution 100ms" },
 * '22': { component: '', title: 'AUTO ON', desc: " O2 Auto ON with timer If the load O2 is OFF, you can schedule it to turn ON automatically after the period of time defined in this parameter. The timer resets to zero each time the device receives an OFF command, either remotely (from the gateway or associated device) or locally from the switch. Values size: 2 Byte Default value: 0 Values & their descriptions: 0 - Auto ON Disabled 1 - 32535 = 1 - 32535 seconds (or milliseconds – see Parameter no. 26. Set timer units to s or ms for O2 resolution 100ms" },
 * '23': { component: '', title: '', desc: " O (O1) contact type - NO/NC The set value determines the relay contact type for output O (O1). The relay contact type can be normally open (NO) or normally closed (NC). Values size: 1 Byte Default value: 0 Values & descriptions: 0 - NO	1 - NC" },
 * '24': { component: '', title: '', desc: " O2 contact type - NO/NC The set value determines the type of Relay contact type for O2 output. The Relay contact type can be normally open (NO) or normally closed (NC). Values size: 1 Byte Default value: 0 Values & descriptions: 0 - NO 1 - NC" },
 * '25': { component: '', title: '', desc: " Set timer units to s or ms for O (O1) Set the timer units to seconds or milliseconds. Choose if you want to set the timer in seconds or milliseconds in Parameters No. 19, 20. Values size: 1 Byte Default value: 0 Values & descriptions: 0 – timer set in seconds 1 – timer set in milliseconds" },
 * '26': { component: '', title: '', desc: " Set timer units to s or ms for O2 Set the timer units to seconds or milliseconds. Choose if you want to set the timer in seconds or milliseconds in Parameters No. 21, 22. Values size: 1 Byte Default value: 0 Values & descriptions: 0 – timer set in seconds 1 – timer set in milliseconds" },
 * '36': { component: '', title: '', desc: " O (O1) Power report on change - percentage This parameter determines the minimum change in consumed power that will result in sending a new report to the gateway. Values size: 1 Byte Default value: 50 Values & descriptions: 0 - reports are disabled 1-100 (1-100%) - change in power" },
 * '37': { component: '', title: '', desc: " O2 Power report on change - percentage This parameter determines the minimum change in consumed power that will result in sending new report to the gateway. Values size: 1 Byte Default value: 50 Values & descriptions: 0 - reports are disabled 1-100 (1-100%) - change in power" },
 * '39': { component: '', title: '', desc: " Minimum time between reports (O) O1 This parameter determines the minimum time that must elapse before a new power report on O (O1) is sent to the gateway. Values size: 1 Byte Default value: 30 Values & descriptions: 0 - reports are disabled 1-120 (1-120s) - report interval" },
 * '40': { component: '', title: '', desc: " Minimum time between reports O2 This parameter determines the minimum time that must elapse before a new power report on O2 is sent to the gateway. Values size: 1 Byte Default value: 30 Values & descriptions: 0 - reports are disabled 1-120 (1-120s) - report interval 10-120 (10-120s) - report interval, remark" },
 * '71': { component: '', title: '', desc: " Operating modes Choose between the two operating modes. In shutter mode, you can select up/down/stop. In venetian mode, an additional widget/endpoint is displayed in the UI interface, which you can use to control the tilt position of the slats. Values size: 1 Byte Default value: 0 Values & descriptions: 0 - Shutter mode 1 - Venetian mode with (up/down and slats rotation)2 – Manual time set (No end switches)" },
 * '72': { component: '', title: '', desc: " Venetian blind slats turning time Set the time required for the slats to make a full turn (180 degrees). ⓘ NOTE: Make sure that working mode is set to venetian (Par. No. 71 =1)Values size: 2 Byte Default value: 150 = 1.5 seconds Values & descriptions: 0 - turning time disabled 1 - 32767 = 0.01 seconds – 327.67 seconds" },
 * '73': { component: '', title: '', desc: " Slats position after moving This parameter is used to enable/disable the slats to return to the previously set position, after being activated via the gateway, push-button operation or when the lower limit switch is reached. Values size: 1 Byte Default value: 1 Values & their descriptions: 0 - disable 1 - enable" },
 * '76': { component: '', title: '', desc: " Motor operation detection Define the power consumption threshold at the end positions. Based on this value, the Device will know that the shutters reached the limit switches. Values size: 1 Byte Default value: 1 Values & their descriptions: 0 - Disabled: reaching a limit switch will not be detected 1 - Auto power calibration 2 - 2-255 (2-255W) - report interval" },
 * '78': { component: '', title: 'CALIBRATION', desc: "  Forced shutter calibration By setting this parameter to value 1 the Device will start executing force calibration procedure. The parameter also reports the calibration status by sending the get parameter value command. NOTE: Check chapter Functionality with calibration details NOTE: During the calibration procedure the blind moves up, down, up, and down to 50%. NOTE: During the calibration procedure the yellow LED is blinking. Values size: 1 Byte Default value: 3 (after factory reset) Values & their descriptions: 1 - start calibration 2 - device is calibrated (read only) 3 - device is not calibrated (read only) 4 - calibration error (read only)" },
 * '80': { component: '', title: '', desc: " Motor stop delay after limit switch detection This parameter defines the delay time for the motor to turn off, after reaching the limit switch. Values size: 1 Byte Default value: 10 Values & their descriptions: Default value 10 = (1s) 0-255 (0-25.5s) - time" },
 * '85': { component: '', title: 'IDLE POWER PERIOD', desc: " Power consumption max delay time Define the maximum time before the power consumption of the motor is read from the Device, after one of the relays is switched on. If there is no power consumption during the set time (motor is not connected, damaged or requires longer time to start, motor is at the end position), the relay will switch off. This time is defined by entering it manually. Values size: 1 Byte Default value: 30 Values & descriptions: 0 = time is set automatically 3 - 50 = 0.3seconds – 5seconds (100ms resolution)" },
 * '91': { component: '', title: 'MOVEMENT TIME LIMITS', desc: " Max. Motor moving time When the shutter is not calibrated (or the motor is not equipped with a limit switch), this parameter defines the movement time of the motor. Values size: 2 Byte Default value: 120 Values & descriptions: value = 1 - 32000s value = 65000 = unlimited time" },
 * '92': { component: '', title: '', desc: " Smoke Alarm This parameter determines which alarm frames the Device should respond to and how. The parameters consist of 4 bytes, the three most significant bytes are set according to the official Z-Wave protocol specification. Values size: 4 Byte Default value: 0 Values & descriptions: 0 no action 1 open relay / Open blinds (Up position) 2 close relay / Close blinds (Down position)" },
 * '93': { component: '', title: '', desc: " CO Alarm This parameter determines which alarm frames the Device should respond to and how. The parameters consist of 4 bytes, the three most significant bytes are set according to the official Z-Wave protocol specification. Values size: 4 Byte Default value: 0 Values & descriptions: 0 no action 1 open relay / Open blinds (Up position) 2 close relay / Close blinds (Down position)" },
 * '94': { component: '', title: '', desc: " Heat Alarm This parameter determines which alarm frames the Device should respond to and how. The parameters consist of 4 bytes, the three most significant bytes are set according to the official Z-Wave protocol specification. Values size: 4 Byte Default value: 0 Values & descriptions: 0 no action 1 open relay / Open blinds (Up position) 2 close relay / Close blinds (Down position)" },
 * '120': { component: '', title: 'FACTORY RESET', desc: " Factory Reset Reset to factory default settings and removed from the z-wave network Values size: 4 Byte Default value: 0 Values & descriptions: 0 - Don’t do Factory reset 1431655765 - Do the Factory reset (hex 0x55555555)" },
 * '201': { component: '', title: '', desc: " Serial Number 1 This parameter contains a part of device’s serial number. The parameter is Read-Only and cannot be changed.	The parameter is Advanced and may be hidden under the Advanced tag. Values size: 4 Byte	Default value: Device specific Values & descriptions: 0x00000000 - 0x7FFFFFFF" },
 * '202': { component: '', title: '', desc: " Serial Number 1 This parameter contains a part of device’s serial number. The parameter is Read-Only and cannot be changed.	The parameter is Advanced and may be hidden under the Advanced tag. Values size: 4 Byte	Default value: Device specific Values & descriptions: 0x00000000 - 0x7FFFFFFF" },
 * '203': { component: '', title: '', desc: " Serial Number 1 This parameter contains a part of device’s serial number. The parameter is Read-Only and cannot be changed.	The parameter is Advanced and may be hidden under the Advanced tag. Values size: 4 Byte	Default value: Device specific Values & descriptions: 0x00000000 - 0x7FFFFFFF" },
 */
//#endregion

//#region reduced settings/features
/**
 * export const Z_WAVE_SETTINGS_COMPONENTS = {
    '1': { component: '', title: '', desc: "SW (SW1) Switch type. This parameter defines how the Device should treat the switch (which type) connected to the SW (SW1) terminal.Value size: 1 Byte Default value: 2 Values & descriptions:0 - momentary switch,1 - toggle switch (contact closed - ON / contact opened - OFF),2 - toggle switch (device changes status when switch changes status)" },
 
Shelly Input type ch.1
 
 

    '2': { component: '', title: '', desc: "SW2 Switch type This parameter defines how the Device should treat the switch (which type) connected to the SW2 terminal. Value size: 1 Byte Default value: 2 Values & descriptions: 0 - momentary switch (push button), 1 - toggle switch (contact closed - ON / contact opened - OFF), 2 - toggle switch (device changes status when switch changes status)" },
 
Shelly Input type ch.2
 
 

    '5': { component: '', title: '', desc: " Output orientation This parameter allows to reverse the operation of O1 and O2 without changing the wiring (in case of invalid motor connection) to ensure proper operation. Value size: 1 Byte Default value: 0 Values & descriptions: 0 - default (O1 - UP, O2 - DOWN) 1 - reversed (O1 - DOWN, O2 - UP)" },
 
INVERT OUTPUT
 

    '6': { component: '', title: '', desc: " Inputs SW1 & SW2 Swap This parameter allows to swap the operation of switches connected to inputs SW1 and SW2 without changing the wiring. Value size: 1 Byte Default value: 0 Values & descriptions: 0 - default (SW1 - O1, SW2 - O2), 1 - swapped (SW1 - O2, SW2 - O1)" }
 
SWAP INPUT
 

    '16': { component: '', title: '', desc: "Outputs O1 & O2 swap This parameter allows to swap the operation of outputs O1 and O2 without changing the wiring (in case of an invalid motor connection) to ensure proper operation. Values size: 1 Byte Default value: 0 Values & descriptions: 0 - default 1 - reversed" },
 
SWAP OUTPUTS

    '17': { component: '', title: '', desc: "Restore state of O (O1) after power failure. This parameter determines if the on/off status is saved and restored for the load connected to O (O1) after a power failure. Values  size: 1 Byte. Default value: 0 Values & descriptions: 0 - Device saves last on/off status and restores it after a power failure 1 - Device does not save on/off status and does not restore it after a power failure, it remains off" },
 
Power on default

    '18': { component: '', title: '', desc: "Restore the O2 state after a power failure This parameter determines if the on/off status is saved and restored for the load connected to O2 after a power failure. Values size: 1 Byte Default value: 0 Values & descriptions: 0 - Device saves last on/off status and restores it after a power failure 1 - Device does not save on/off status and does not restore it after a power failure, it remains off" },
 
Power on default
 

    '19': { component: '', title: '', desc: " O (O1) Auto OFF with timer If the load O (O1) is ON, you can schedule it to turn OFF automatically after the period of time defined in this parameter. The timer resets to zero each time the Device receives an ON command, either remotely (from the gateway or associated device) or locally from the switch. Values size: 2 Byte Default value: 0 Values & their descriptions: 0 - Auto OFF Disabled 1 - 32535 = 1 - 32535 seconds or milliseconds – see Parameter no. 25. Set timer units to s or ms for O (O1) resolution 100ms" },
 
Auto OFF
 

    '20': { component: '', title: '', desc: " O (O1) Auto ON with timer If the load O (O1) is ON, you can schedule it to turn OFF automatically after the period of time defined in this parameter. The timer resets to zero each time the Device receives an ON command, either remotely (from the gateway or associated device) or locally from the switch. Values size: 2 Byte Default value: 0 Values & their descriptions: 0 - Auto ON Disabled 1 - 32535 = 1 - 32535 seconds (or milliseconds – see Parameter No. 25. Set timer units to s or ms for O (O1) resolution 100ms" },
 
Auto ON

    '21': { component: '', title: '', desc: " O2 Auto OFF with timer If the load O2 is ON, you can schedule it to turn OFF automatically after the period of time defined in this parameter. The timer resets to zero each time the device receives an ON command, either remotely (from the gateway or associated device) or locally from the switch. Values size: 2 Byte Default value: 0 Values & their descriptions: 0 - Auto OFF Disabled1 - 32535 = 1 - 32535 seconds (or milliseconds – see Parameter no. 26. Set timer units to s or ms for O2 resolution 100ms" },
 
- AUTO OFF

    '22': { component: '', title: '', desc: " O2 Auto ON with timer If the load O2 is OFF, you can schedule it to turn ON automatically after the period of time defined in this parameter. The timer resets to zero each time the device receives an OFF command, either remotely (from the gateway or associated device) or locally from the switch. Values size: 2 Byte Default value: 0 Values & their descriptions: 0 - Auto ON Disabled 1 - 32535 = 1 - 32535 seconds (or milliseconds – see Parameter no. 26. Set timer units to s or ms for O2 resolution 100ms" },
 
-AUTO ON

    '78': { component: '', title: '', desc: "  Forced shutter calibration By setting this parameter to value 1 the Device will start executing force calibration procedure. The parameter also reports the calibration status by sending the get parameter value command. NOTE: Check chapter Functionality with calibration details NOTE: During the calibration procedure the blind moves up, down, up, and down to 50%. NOTE: During the calibration procedure the yellow LED is blinking. Values size: 1 Byte Default value: 3 (after factory reset) Values & their descriptions: 1 - start calibration 2 - device is calibrated (read only) 3 - device is not calibrated (read only) 4 - calibration error (read only)" }
 
CALIBRATION (1), (2,3 – дали да показваме слайдър), 4 (грешки)
 

    '85': { component: '', title: '', desc: " Power consumption max delay time Define the maximum time before the power consumption of the motor is read from the Device, after one of the relays is switched on. If there is no power consumption during the set time (motor is not connected, damaged or requires longer time to start, motor is at the end position), the relay will switch off. This time is defined by entering it manually. Values size: 1 Byte Default value: 30 Values & descriptions: 0 = time is set automatically 3 - 50 = 0.3seconds – 5seconds (100ms resolution)" },
 
IDLE POWER PERIOD
 

    '91': { component: '', title: '', desc: " Max. Motor moving time When the shutter is not calibrated (or the motor is not equipped with a limit switch), this parameter defines the movement time of the motor. Values size: 2 Byte Default value: 120 Values & descriptions: value = 1 - 32000s value = 65000 = unlimited time" },
 
MOVEMENT TIME LIMITS
 
 

    '120': { component: '', title: '', desc: " Factory Reset Reset to factory default settings and removed from the z-wave network Values size: 4 Byte Default value: 0 Values & descriptions: 0 - Don’t do Factory reset 1431655765 - Do the Factory reset (hex 0x55555555)" },
 
FACTORY RESET
 
 */
//#endregion

//#region zWave settings per device type
export const Z_WAVE_REQUIRED_SETTINGS = {
	'QNSW-001X16': [
		'1',
		'17',
		'19',
		'20',
		'23',
		'25',
		'91',
		'92',
		'93',
		'94',
		'119',
		'120',
		'201',
		'202',
		'203',
	], //wave 1
	'QNSW-001P16': [
		'1',
		'17',
		'19',
		'20',
		'23',
		'25',
		'36',
		'39',
		'91',
		'92',
		'93',
		'94',
		'119',
		'120',
		'201',
		'202',
		'203',
		'220',
	], //wave 1 pm
	'QNSW-002P16': [
		'1',
		'2',
		'6',
		'16',
		'17',
		'18',
		'19',
		'20',
		'21',
		'22',
		'23',
		'24',
		'25',
		'26',
		'36',
		'37',
		'39',
		'40',
		'91',
		'92',
		'93',
		'94',
		'120',
		'201',
		'202',
		'203',
	], //wave 2 pm
	'QNSH-001P10': [
		'1',
		'3',
		'5',
		'40',
		'51',
		'52',
		'53',
		'54',
		'71',
		'72',
		'73',
		'74',
		'75',
		'76',
		'77',
		'78',
		'80',
		'85',
		'90',
		'91',
		'120',
	], //wave shutter
}; //NOTE: missing desc for 51, 52, 53, 54, 74, 75, 90, 119

export const Z_WAVE_SETTINGS_COMPONENTS = {
	'-1': {
		setting: {
			title: 'application_settings',
			components: [
				{
					title: 'pin_lock',
					component: 'pin_lock',
				},
				{
					title: 'consumption_calculation',
					component: 'consumption_calculation',
				},
			],
		},
	},
	'0': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'device_information',
					component: 'device_information',
				},
				{
					title: 'firmware_update',
					component: 'firmware_update_z',
				},
				// {
				//     title: 'exotic_settings',
				//     component: 'exotic_settings_z'
				// },//TODO: add exotic settings - advanced settings for zwave
			],
		},
	},
	'1': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'input_type',
					component: 'input_type_z',
				},
			],
		},
		title: 'Input type',
		desc: 'SW (SW1) Switch type. This parameter defines how the Device should treat the switch (which type) connected to the SW (SW1) terminal.Value size: 1 Byte Default value: 2 Values & descriptions:0 - momentary switch,1 - toggle switch (contact closed - ON / contact opened - OFF),2 - toggle switch (device changes status when switch changes status)',
	},
	'2': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'input_type',
					component: 'input_type_z',
				},
			],
		},
		title: 'Input type',
		desc: 'SW2 Switch type This parameter defines how the Device should treat the switch (which type) connected to the SW2 terminal. Value size: 1 Byte Default value: 2 Values & descriptions: 0 - momentary switch (push button), 1 - toggle switch (contact closed - ON / contact opened - OFF), 2 - toggle switch (device changes status when switch changes status)',
	},
	'5': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'invert_output',
					component: 'invert_output_z',
				},
			],
		},
		title: 'INVERT OUTPUT',
		desc: ' Output orientation This parameter allows to reverse the operation of O1 and O2 without changing the wiring (in case of invalid motor connection) to ensure proper operation. Value size: 1 Byte Default value: 0 Values & descriptions: 0 - default (O1 - UP, O2 - DOWN) 1 - reversed (O1 - DOWN, O2 - UP)',
	},
	'6': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'swap_input',
					component: 'swap_inputs_z',
				},
			],
		},
		title: 'SWAP INPUT',
		desc: ' Inputs SW1 & SW2 Swap This parameter allows to swap the operation of switches connected to inputs SW1 and SW2 without changing the wiring. Value size: 1 Byte Default value: 0 Values & descriptions: 0 - default (SW1 - O1, SW2 - O2), 1 - swapped (SW1 - O2, SW2 - O1)',
	},
	'16': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'swap_outputs',
					component: 'swap_outputs_z',
				},
			],
		},
		title: 'SWAP OUTPUTS',
		desc: 'Outputs O1 & O2 swap This parameter allows to swap the operation of outputs O1 and O2 without changing the wiring (in case of an invalid motor connection) to ensure proper operation. Values size: 1 Byte Default value: 0 Values & descriptions: 0 - default 1 - reversed',
	},
	'17': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'power_on_default',
					component: 'power_on_default_z',
				},
			],
		},
		title: 'Power on default',
		desc: 'Restore state of O (O1) after power failure. This parameter determines if the on/off status is saved and restored for the load connected to O (O1) after a power failure. Values  size: 1 Byte. Default value: 0 Values & descriptions: 0 - Device saves last on/off status and restores it after a power failure 1 - Device does not save on/off status and does not restore it after a power failure, it remains off',
	},
	'18': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'power_on_default',
					component: 'power_on_default_z',
				},
			],
		},
		title: 'Power on default',
		desc: 'Restore the O2 state after a power failure This parameter determines if the on/off status is saved and restored for the load connected to O2 after a power failure. Values size: 1 Byte Default value: 0 Values & descriptions: 0 - Device saves last on/off status and restores it after a power failure 1 - Device does not save on/off status and does not restore it after a power failure, it remains off',
	},
	'19': {
		setting: {
			title: 'timer',
			components: [
				{
					title: 'auto',
					component: 'auto_gen_z',
				},
			],
		},
		title: 'Auto OFF',
		desc: ' O (O1) Auto OFF with timer If the load O (O1) is ON, you can schedule it to turn OFF automatically after the period of time defined in this parameter. The timer resets to zero each time the Device receives an ON command, either remotely (from the gateway or associated device) or locally from the switch. Values size: 2 Byte Default value: 0 Values & their descriptions: 0 - Auto OFF Disabled 1 - 32535 = 1 - 32535 seconds or milliseconds – see Parameter no. 25. Set timer units to s or ms for O (O1) resolution 100ms',
	},
	'20': {
		setting: {
			title: 'timer',
			components: [
				{
					title: 'auto',
					component: 'auto_gen_z',
				},
			],
		},
		title: 'Auto ON',
		desc: ' O (O1) Auto ON with timer If the load O (O1) is ON, you can schedule it to turn OFF automatically after the period of time defined in this parameter. The timer resets to zero each time the Device receives an ON command, either remotely (from the gateway or associated device) or locally from the switch. Values size: 2 Byte Default value: 0 Values & their descriptions: 0 - Auto ON Disabled 1 - 32535 = 1 - 32535 seconds (or milliseconds – see Parameter No. 25. Set timer units to s or ms for O (O1) resolution 100ms',
	},
	'21': {
		setting: {
			title: 'timer',
			components: [
				{
					title: 'auto',
					component: 'auto_gen_z',
				},
			],
		},
		title: 'AUTO OFF',
		desc: ' O2 Auto OFF with timer If the load O2 is ON, you can schedule it to turn OFF automatically after the period of time defined in this parameter. The timer resets to zero each time the device receives an ON command, either remotely (from the gateway or associated device) or locally from the switch. Values size: 2 Byte Default value: 0 Values & their descriptions: 0 - Auto OFF Disabled1 - 32535 = 1 - 32535 seconds (or milliseconds – see Parameter no. 26. Set timer units to s or ms for O2 resolution 100ms',
	},
	'22': {
		setting: {
			title: 'timer',
			components: [
				{
					title: 'auto',
					component: 'auto_gen_z',
				},
			],
		},
		title: 'AUTO ON',
		desc: ' O2 Auto ON with timer If the load O2 is OFF, you can schedule it to turn ON automatically after the period of time defined in this parameter. The timer resets to zero each time the device receives an OFF command, either remotely (from the gateway or associated device) or locally from the switch. Values size: 2 Byte Default value: 0 Values & their descriptions: 0 - Auto ON Disabled 1 - 32535 = 1 - 32535 seconds (or milliseconds – see Parameter no. 26. Set timer units to s or ms for O2 resolution 100ms',
	},
	'78': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'calibration',
					component: 'calibration_z',
				},
			],
		},
		title: 'CALIBRATION',
		desc: '  Forced shutter calibration By setting this parameter to value 1 the Device will start executing force calibration procedure. The parameter also reports the calibration status by sending the get parameter value command. NOTE: Check chapter Functionality with calibration details NOTE: During the calibration procedure the blind moves up, down, up, and down to 50%. NOTE: During the calibration procedure the yellow LED is blinking. Values size: 1 Byte Default value: 3 (after factory reset) Values & their descriptions: 1 - start calibration 2 - device is calibrated (read only) 3 - device is not calibrated (read only) 4 - calibration error (read only)',
	},
	'85': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'idle_power_period',
					component: 'idle_power_period_z',
				},
			],
		},
		title: 'IDLE POWER PERIOD',
		desc: ' Power consumption max delay time Define the maximum time before the power consumption of the motor is read from the Device, after one of the relays is switched on. If there is no power consumption during the set time (motor is not connected, damaged or requires longer time to start, motor is at the end position), the relay will switch off. This time is defined by entering it manually. Values size: 1 Byte Default value: 30 Values & descriptions: 0 = time is set automatically 3 - 50 = 0.3seconds – 5seconds (100ms resolution)',
	},
	'91': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'water_alarm',
					component: 'water_alarm_z',
				},
			],
		},
		title: 'MOVEMENT TIME LIMITS',
		desc: ' Max. Motor moving time When the shutter is not calibrated (or the motor is not equipped with a limit switch), this parameter defines the movement time of the motor. Values size: 2 Byte Default value: 120 Values & descriptions: value = 1 - 32000s value = 65000 = unlimited time',
	},
	'91R': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'movement_time_limits',
					component: 'movement_time_limits_z',
				},
			],
		},
		title: 'MOVEMENT TIME LIMITS',
		desc: ' Max. Motor moving time When the shutter is not calibrated (or the motor is not equipped with a limit switch), this parameter defines the movement time of the motor. Values size: 2 Byte Default value: 120 Values & descriptions: value = 1 - 32000s value = 65000 = unlimited time',
	}, //TODO - need new key for movement time limits. Will comment this because for 3 other device types this is water alarm.
	'92': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'smoke_alarm',
					component: 'smoke_alarm_z',
				},
			],
		},
		title: 'SMOKE ALARM',
		desc: ' This parameter determines which alarm frames the Device should respond to and how. The parameters consist of 4 bytes, the three most significant bytes are set according to the official Z-Wave protocol specification. 0 no action, 1 open relay, 2 close relay. Values size: 4 Byte Default value: 0 Values & descriptions: 0 no action 1 open relay / Open blinds (Up position) 2 close relay / Close blinds (Down position)',
	},
	'93': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'co_alarm',
					component: 'co_alarm_z',
				},
			],
		},
		title: 'CO ALARM',
		desc: ' This parameter determines which alarm frames the Device should respond to and how. The parameters consist of 4 bytes, the three most significant bytes are set according to the official Z-Wave protocol specification. 0 no action, 1 open relay, 2 close relay. Values size: 4 Byte Default value: 0 Values & descriptions: 0 no action 1 open relay / Open blinds (Up position) 2 close relay / Close blinds (Down position)',
	},
	'94': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'heat_alarm',
					component: 'heat_alarm_z',
				},
			],
		},
		title: 'HEAT ALARM',
		desc: ' This parameter determines which alarm frames the Device should respond to and how. The parameters consist of 4 bytes, the three most significant bytes are set according to the official Z-Wave protocol specification. 0 no action, 1 open relay, 2 close relay. Values size: 4 Byte Default value: 0 Values & descriptions: 0 no action 1 open relay / Open blinds (Up position) 2 close relay / Close blinds (Down position)',
	},
	'120': {
		setting: {
			title: 'settings',
			components: [
				{
					title: 'factory_reset',
					component: 'factory_reset_z',
				},
			],
		},
		title: 'FACTORY RESET',
		desc: ' Factory Reset Reset to factory default settings and removed from the z-wave network Values size: 4 Byte Default value: 0 Values & descriptions: 0 - Don’t do Factory reset 1431655765 - Do the Factory reset (hex 0x55555555)',
	},
};
//#endregion

export const get_wave_device_settings = (
	config: { [key: string]: number },
	type: string,
): Array<{ title: string; components: Array<any> }> => {
	const components: Array<{ title: string; components: Array<any> }> = [
		JSON.parse(JSON.stringify({ ...Z_WAVE_SETTINGS_COMPONENTS['-1'].setting })),
	];
	if (typeof config !== 'undefined') {
		components.push({ ...Z_WAVE_SETTINGS_COMPONENTS['0'].setting });
		Object.keys(config).forEach((key) => {
			if (type === 'QNSH-001P10' && key === '91') key = '91R'; //TODO - need new key for movement time limits. This is temporary fix for QNSH-001P10
			const setting =
				typeof Z_WAVE_SETTINGS_COMPONENTS[key] !== 'undefined' &&
				Z_WAVE_SETTINGS_COMPONENTS[key]?.setting;

			if (setting) {
				// Check if the components array is empty
				// if (components.length === 0) {
				//     // If it is empty, create a new object by spreading the properties of Z_WAVE_SETTINGS_COMPONENTS['0'].setting
				//     components.push();
				// }

				// Find the index of an existing component with a matching title
				const existingComponentIndex = components.findIndex((c) => c.title === setting.title);

				if (existingComponentIndex !== -1) {
					// Add the components of the setting object to the existing component's components array
					components[existingComponentIndex].components.push(...setting.components);

					// Remove any duplicate components from the existing component's components array
					components[existingComponentIndex].components = [
						...new Set(components[existingComponentIndex].components.map(JSON.stringify)),
					].map(JSON.parse);
				} else {
					// If no existing component is found, push the setting object to the components array
					components.push(setting);
				}
			}
		});
	}

	// Sort the components array based on the title property in ascending order
	return components.sort((a, b) => b.title.localeCompare(a.title));
};
